import { NavLink } from 'react-router-dom';

const groups = [
  { title: '22Play', links: [['About us', '/information/about'], ['Contact', '/information/contact'], ['Affiliate program', '/information/affiliates'], ['Mobile apps', '/mobile']] },
  { title: 'Betting', links: [['Sports', '/sports'], ['Live', '/live'], ['Results', '/results'], ['Statistics', '/statistics']] },
  { title: 'Games', links: [['Casino', '/casino'], ['Live casino', '/live-casino'], ['Fast games', '/fast-games'], ['Promotions', '/promotions']] },
  { title: 'Information', links: [['Terms and conditions', '/information/rules'], ['Privacy policy', '/information/privacy'], ['Cookie policy', '/information/cookies'], ['Responsible play', '/information/responsible-play']] },
];

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__groups">
        {groups.map((group) => <section key={group.title}><h2>{group.title}</h2>{group.links.map(([label, path]) => <NavLink key={path} to={path}>{label}</NavLink>)}</section>)}
      </div>
      <details className="footer-details"><summary>Sports betting and casino information</summary><p>This independent frontend reconstruction uses mock event data and original artwork. It does not accept wagers, process payments, or connect to proprietary services.</p></details>
      <div className="site-footer__bottom"><p>Play responsibly. Adults 18+ only.</p><span className="age-badge">18+</span></div>
    </footer>
  );
}
